/* eslint-disable @typescript-eslint/no-var-requires */
import Vue from 'vue';
import moment from 'moment';
// import moment from 'moment-timezone';
Vue.use(require('vue-moment'), { moment });
